import { Namespace } from 'i18next';
import { fanfanloI18n } from '.';
/**
 * 
 * @param namespace 命名空间。到各自所在库的types目录里的i18n-resources.ts里找对于的文件路径即可。
 * @param key 值的key
 * @returns 
 */
export async function loadI18nValue(namespace: Namespace, key: string) {
  // console.log('fanfanloI18n.language=', fanfanloI18n.language)
  // if (!fanfanloI18n.hasLoadedNamespace(namespace)) {
  //   // console.log('loading namespace', namespace)
  //   await fanfanloI18n.loadNamespaces([namespace as string]);
  // }else{
  //   // console.log('namespace already loaded', namespace)
  // }
  // const t = fanfanloI18n.getFixedT(null, namespace);
  const t = await getI18nT(namespace);
  const res =  t(key as any);
  return res
}

export async function getI18nT(namespace:Namespace){
  // console.log('fanfanloI18n.language=', fanfanloI18n.language)
  if (!fanfanloI18n.hasLoadedNamespace(namespace)) {
    // console.log('loading namespace', namespace)
    await fanfanloI18n.loadNamespaces([namespace as string]);
  }else{
    // console.log('namespace already loaded', namespace)
  }
  const t = fanfanloI18n.getFixedT(null, namespace);
  return t
}